import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import { Player, ControlBar } from 'video-react';
// import { AppSettings } from '../../constants';
import InputEditAble from 'components/inputEditAble';
import { PreviewImage } from 'components/PreviewImage';
// import PDFViewer from 'components/PDF';
import Flowpaper from 'components/Flowpaper';
import ConfirmationRemoveFileModal from './confirmation-remove-file-modal';
import videoIcon from 'assets/img/file_video.png';
import 'video-react/dist/video-react.css';

class HomeDocumentSectionItem extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    data: PropTypes.object,
    onRemoveDocument: PropTypes.func,
    onUpdateFileName: PropTypes.func,
    onCancelUpload: PropTypes.func,
    onClickShareWithLot: PropTypes.func,
    mode: PropTypes.string,
    manualType: PropTypes.number
  };

  constructor(props) {
    super(props);
    this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    this.uuid = uuidv4();
    this.state = {
      isEditFileName: false,
      openModalConfirmRemoveFile: false,
      thumbnailWidth: 0,
      videoThumbnailWidth: 0,
      showDialog: false,
      player: {
        paused: true,
        videoHeight: 0,
        videoWidth: 0
      }
    };
  }

  componentDidMount() {
    document.addEventListener('click', this.handleHideEmbedPreview);
    this.onSetThumbnailWrapperWidth();
    // subscribe state change
    if (this.refs.player) {
      this.refs.player.subscribeToStateChange(this.handleStateChange);
    }
  }

  componentDidUpdate() {
    this.onSetThumbnailWrapperWidth();
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleHideEmbedPreview);
  }

  onSetThumbnailWrapperWidth() {
    const nameSpanId = `doc-file-name-${this.uuid}`;

    const { fileName } = this.props.data;

    let interval = setInterval(() => {
      let nameRender = fileName;
      const thumbnailWidth = document.getElementById(this.uuid)
        ? document.getElementById(this.uuid).offsetWidth
        : 0;
      if (thumbnailWidth <= 0) {
        nameRender = '';
      }
      if (thumbnailWidth > 0) {
        if (fileName.length * 9 > thumbnailWidth * 2 - 60) {
          const newFileName = fileName.slice(0, (thumbnailWidth * 2 - 60) / 9);
          nameRender = newFileName + '...';
        }
        clearInterval(interval);
      }
      if (document.getElementById(nameSpanId)) {
        document.getElementById(nameSpanId).innerText = nameRender;
      }
    }, 50);
  }

  onToggleEditFileName = () => {
    this.setState({
      isEditFileName: !this.state.isEditFileName
    });
  };

  onUpdateFileName = param => {
    const { data } = this.props;

    const splitUrl = data.url.split('.');

    const fileExtension = splitUrl[splitUrl.length - 1];

    this.props.onUpdateFileName(
      data.id,
      { ...param, fileName: `${param.fileName}.${fileExtension}` },
      this.onToggleEditFileName
    );
  };

  handleRemoveDocument = () => {
    const { loading, onCancelUpload, data } = this.props;

    if (!loading) {
      this.setState({
        openModalConfirmRemoveFile: true,
        removeDocumentId: data.id
      });
    } else {
      onCancelUpload(data);
    }
  };

  onCloseConfirmRemoveFileModal = () => {
    this.setState({
      openModalConfirmRemoveFile: false,
      removeDocumentId: null
    });
  };

  onRemoveFileConfirmed = () => {
    const { removeDocumentId } = this.state;

    this.props.onRemoveDocument(removeDocumentId);
  };

  handlePreview = () => {
    const { loading, data, manualType } = this.props;

    if (!loading) {
      //pdfUrl used to be here, but changed cause integrate of Flowpaper, we change instead of using url, we are using key here
      const { url, key } = data;

      const imageType = ['jpg', 'jpeg', 'png'];

      if (
        imageType.includes(
          url
            .split('.')
            .pop()
            .toLowerCase()
        )
      ) {
        this.setState({
          show: true,
          imageUrl: url
        });
      }
      if (
        url
          .split('.')
          .pop()
          .toLowerCase() === 'pdf'
      ) {
        this.setState({
          pdfS3Key: key,
          pdfPreviewUrl: url,
          isOpen: true
        });
      }

      if (manualType === 1) {
        this.refs.player.play();
        const { player } = this.state;
        const isIOS =
          /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        if (
          this.isMobile &&
          !isIOS &&
          (!player || (player && !player.isFullscreen))
        ) {
          this.refs.player.toggleFullscreen();
        }
      }
    }
  };

  handleClosePreviewImage = () => {
    this.setState({
      show: false,
      imageUrl: null
    });
  };

  onClosePDFViewer = () => {
    this.setState({
      pdfPreviewUrl: null,
      pdfS3Key: null,
      isOpen: false
    });
  };

  handleHideEmbedPreview = event => {
    if (
      this.embedPreview &&
      !this.embedPreview.contains(event.target) &&
      !this.viewIcon.contains(event.target)
    ) {
      this.setState({
        pdfPreviewUrl: null,
        pdfS3Key: null
      });
    }
  };

  onClickShareWithLot = () => {
    const { data, onClickShareWithLot, loading } = this.props;
    if (!loading) {
      onClickShareWithLot(data);
    }
  };

  onDetectFileName = data => {
    const { fileName } = data;

    if (fileName.includes('.')) {
      const splitFileName = fileName.split('.');

      const fileExtension = splitFileName[splitFileName.length - 1];

      const name = fileName.replace(`.${fileExtension}`, '');

      return name;
    }

    return fileName;
  };

  handleStateChange = (state, prevState) => {
    if (
      state.paused !== prevState.paused ||
      state.isFullscreen !== prevState.isFullscreen
    ) {
      this.setState({ player: state }, () => {
        if (this.isMobile) {
          if (!state.isFullscreen && !prevState.paused) {
            this.refs.player.pause();
          }
        } else {
          if (!state.paused && !this.state.showDialog) {
            this.setState({ showDialog: true, player: state }, () => {
              this.onToggleBodyScroll(false);
            });
          }
        }
      });
    }
  };

  onToggleBodyScroll = allowed => {
    if (allowed) {
      //allowed === true then allow body scroll
      document
        .getElementsByTagName('BODY')[0]
        .classList.remove('body-not-scroll');
    } else {
      //allowed === false then prevent body scroll
      document.getElementsByTagName('BODY')[0].classList.add('body-not-scroll');
    }
  };

  onCloseVideoDialog = () => {
    this.setState(
      {
        showDialog: false
      },
      () => {
        this.refs.player.pause();
        this.onToggleBodyScroll(true);
      }
    );
  };

  renderLoading = loading => {
    if (loading) {
      return <i className='fa fa-spin fa-spinner loading-icon' />;
    }

    return null;
  };

  renderFuncButton = () => {
    const { loading, mode } = this.props;

    if (loading) {
      return (
        <i
          className='fa fa-trash cancel-icon func-icon'
          onClick={this.handleRemoveDocument}
        />
      );
    } else {
      if (mode === 'project') {
        return (
          <React.Fragment>
            <i
              className='fa fa-trash remove-icon func-icon'
              onClick={this.handleRemoveDocument}
            />
            <i
              className='fa fa-eye view-icon func-icon'
              onClick={this.handlePreview}
              ref={ref => {
                this.viewIcon = ref;
              }}
            />
          </React.Fragment>
        );
      } else {
        return (
          <i
            className='fa fa-eye homeowner-view-icon func-icon'
            onClick={this.handlePreview}
            ref={ref => {
              this.viewIcon = ref;
            }}
          />
        );
      }
    }
  };

  renderPdfPreview = () => {
    //change to pdfS3Key to use Flowpaper, before is pdfUrl
    if (this.props.data) {
      // if (AppSettings.clientTypeValue === 'Builder') {
      // return (
      //   <React.Fragment>
      //     <embed
      //       src={pdfPreviewUrl}
      //       className='pdf-preview-dialog'
      //       ref={ref => {
      //         this.embedPreview = ref;
      //       }}
      //     />
      //     <i className='close-embed-preview fa fa-close' />
      //   </React.Fragment>
      // );
      // }

      // return (
      //   <PDFViewer
      //     url={pdfPreviewUrl}
      //     onClosePDFViewer={this.onClosePDFViewer}
      //   />
      // );
      return (
        <Flowpaper
          // url={pdfS3Key}
          data={this.props.data}
          isOpen={this.state.isOpen}
          onCloseFlowpaper={this.onClosePDFViewer}
        />
      );
    }

    return null;
  };

  renderAuthor = () => {
    const { data, mode } = this.props;

    if (mode === 'project') {
      return (
        <div className='author-line'>
          Uploaded by <span className='actor'>{data.createdBy}</span>
        </div>
      );
    }
    return null;
  };

  render() {
    const {
      isEditFileName,
      show,
      imageUrl,
      // pdfPreviewUrl,
      // pdfS3Key,
      openModalConfirmRemoveFile
    } = this.state;

    const { loading, data, mode, manualType } = this.props;

    const defaultFileName = this.onDetectFileName(data);

    const { showDialog, player } = this.state;

    const { videoHeight, videoWidth } = player;

    const dialogClassName = showDialog
      ? 'project-video-dialog'
      : 'project-video-item-wrapper';

    const videoItemClassName = showDialog
      ? 'project-video-playing-item'
      : 'project-video-item thumbnail-wrapper-item';

    const videoRatio = videoWidth / videoHeight;

    const videoPlayingItemHeight = window.innerHeight * 0.8;

    const videoPlayingItemWidth = videoPlayingItemHeight * videoRatio;

    const videoItemLoadingStyle = {
      background: '#e6e6e6',
      border: '1px solid #d9d9d9',
      borderRadius: 2
    };

    let videoItemStyle = !showDialog
      ? { height: 150 }
      : { height: videoPlayingItemHeight, width: videoPlayingItemWidth };

    if (loading) {
      videoItemStyle = { ...videoItemStyle, ...videoItemLoadingStyle };
    }

    const disableControlBar =
      !player ||
      (!this.isMobile && !showDialog) ||
      (this.isMobile && !player.isFullscreen);

    return (
      <div
        ref={ref => {
          this.thumbnailWrapper = ref;
        }}
        id={this.uuid}
        className='project-document-item-wrapper manage-search col-sm-4 col-md-4 col-lg-3'
      >
        {this.renderPdfPreview(data)}

        <PreviewImage
          show={show}
          imageUrl={imageUrl}
          handleClose={this.handleClosePreviewImage}
        />

        {manualType === 0 ? (
          <div className='document-thumbnail-wrapper thumbnail-wrapper-item'>
            {!loading && (
              <img
                src={data.thumbnailUrl}
                alt='s1-document'
                className='document-thumbnail'
              />
            )}
            <div className='document-fade' />

            {this.renderAuthor()}

            {this.renderFuncButton()}

            {this.renderLoading(loading)}
          </div>
        ) : (
          <div className={dialogClassName}>
            {showDialog && (
              <React.Fragment>
                <div className='project-video-fade' />
                <i
                  className='fa fa-close close-video-btn'
                  onClick={this.onCloseVideoDialog}
                />
              </React.Fragment>
            )}
            <div className={videoItemClassName} style={videoItemStyle}>
              {loading ? (
                <img
                  src={videoIcon}
                  alt='s1-video-icon'
                  className='video-icon'
                />
              ) : (
                <Player
                  ref='player'
                  fluid={false}
                  height='100%'
                  preload='metadata'
                >
                  <source src={data.url} />
                  <ControlBar disableCompletely={disableControlBar} />
                </Player>
              )}

              <div className='document-fade' />

              {this.renderAuthor()}

              {this.renderFuncButton()}

              {loading && <i className='fa fa-spin fa-spinner loading-icon' />}
            </div>
          </div>
        )}

        <div className='file-name'>
          {isEditFileName ? (
            <InputEditAble
              defaultValue={defaultFileName}
              inputName='fileName'
              autoFocus
              maxLength='200'
              onSubmit={this.onUpdateFileName}
              onCancel={this.onToggleEditFileName}
            />
          ) : (
            <div className='document-name-block'>
              <span
                id={`doc-file-name-${this.uuid}`}
                style={{ fontWeight: 600 }}
              />

              {mode === 'project' && (
                <i
                  className='fa fa-pencil subcontractor-edit-trade-btn'
                  onClick={this.onToggleEditFileName}
                />
              )}
            </div>
          )}
        </div>
        {mode === 'project' && (
          <div>
            <i
              className='icon-lots-ic'
              aria-hidden='true'
              style={{
                cursor: 'auto',
                marginLeft: -4,
                display: 'inline-block',
                transform: 'translateY(1px)',
                fontSize: 18
              }}
            />
            Shared with{' '}
            <span className='numOfLot' onClick={this.onClickShareWithLot}>
              {' '}
              {data.numberOfSharedLots}
            </span>{' '}
            lots
          </div>
        )}

        {openModalConfirmRemoveFile && (
          <ConfirmationRemoveFileModal
            isOpen={openModalConfirmRemoveFile}
            item={data}
            onClose={this.onCloseConfirmRemoveFileModal}
            onRemove={this.onRemoveFileConfirmed}
          />
        )}
      </div>
    );
  }
}

export default HomeDocumentSectionItem;



// WEBPACK FOOTER //
// ./src/Projects/Components/Document/home-document-section-item.js